/**
* Helpers for processing various HTTP method calls
*/
import { RequestBuilder } from '@cvent/nucleus-networking';
import Logger from '@cvent/nucleus-logging';
const LOG = new Logger('nucleus-widgets/utils/ApiHelpers');

/**
* GET method call
*/
export function get(url, authToken, headers = new Headers()) {
  return fetch(new RequestBuilder({
    url,
    headers
  })
  .auth(authToken)
  .get()
  .build());
}

/**
* POST method call
*/
export function post(url, body, authToken, headers = new Headers()) {
  return fetch(new RequestBuilder({
    url,
    headers
  })
  .json(body)
  .auth(authToken)
  .post()
  .build());
}

/**
* PUT method call
*/
export function put(url, body, authToken, headers = new Headers()) {
  return fetch(new RequestBuilder({
    url,
    headers
  })
  .json(body)
  .auth(authToken)
  .put()
  .build());
}

/**
* Helper function for logging api errors.
*/
export function logError(method, response) {
  const responseCopy = response.clone();
  return response.text().then(text => {
    LOG.error(`${method}: ${response.status} ${response.statusText}: ${text}`);
    return Promise.reject(responseCopy);
  });
}
